import styles from "./rule-of-72.module.css"

import React from "react"
import * as shared from "activities/components/shared"
import * as util from "activities/util"
import * as inputs from "activities/components/inputs"
import * as callouts from "activities/components/callouts"
import assign from "object-assign"

export default shared.ActivityFactory(
  ({getState, getProps, updateState}) => {
    const {rate, resetKey} = getState()
    const years72 = util.get72(rate)
    return (
      <div>
        <shared.Content className={styles["content"]}>
          <shared.Calculator className={styles["calculator"]}>
            <inputs.Input id="rule-72-interest" size="big" title="Interest Rate" valueType="percent" value={rate} onChange={updateState("rate")} />
          </shared.Calculator>
        </shared.Content>
        <callouts.Callout>
          <callouts.Detail label="Rule of 72 Years" result={years72 == Infinity ? "-- Years" : `${util.round(years72, 1)} Years`} dataTestId="rule-years" />
        </callouts.Callout>
      </div>
    )
  },
  {
    stateFilter: (state) => {
      const {rate} = state
      return assign(state, {years: util.get72(rate)})
    },
    defaultProps: {
      id: "rule-of-72",
      className: "rule-of-72",
      title: "Rule of 72 by Interest Rate",
      subtitle: "See how long it would take to double your investment by the interest rate you enter."
    },
    defaultState: {
      rate: 8
    }
  }
)
